import { Button } from "reactstrap";
import "./index.css";
const AddNewComponentFooter = ({
  selectedStudent,
  commentsObj,
  addCommentHandler,
  viewCommentHandler,
}: any) => {
  return (
    <div className="filterFooter w-100 p-0 flex-column studentPerformanceFooter">
      <div className="mobieViewCommentDiv">
        <div className="d-flex">
          <span className="meetingSpan mr-2">
            LOP: {commentsObj?.followUpComments?.length || 0}
          </span>
          <span className="meetingSpan mr-2">
            PTM: {commentsObj?.ptmComments?.length || 0}
          </span>
          <span className="meetingSpan">
            Absentee: {commentsObj?.absenteeComments?.length || 0}
          </span>
        </div>
        {selectedStudent && (
          <div>
            <Button
              onClick={() => {
                viewCommentHandler();
              }}
              color={"aeslPrimary"}
              outline
              className="w-100"
            >
              View Comment
            </Button>
          </div>
        )}
      </div>
      {selectedStudent && (
        <div>
          <Button
            onClick={() => {
              addCommentHandler();
            }}
            color={"aeslPrimary"}
            className="w-100"
          >
            Add Comment
          </Button>
        </div>
      )}
    </div>
  );
};
export default AddNewComponentFooter;
